type LogLevel = 'info' | 'success' | 'warn' | 'error';

interface Logger {
  info: (message: string, ...args: unknown[]) => void;
  success: (message: string, ...args: unknown[]) => void;
  warn: (message: string, ...args: unknown[]) => void;
  error: (message: string, ...args: unknown[]) => void;
}

const STYLES: Record<LogLevel, string> = {
  info: 'color: #38bdf8; font-weight: 600;',
  success: 'color: #22c55e; font-weight: 600;',
  warn: 'color: #f59e0b; font-weight: 600;',
  error: 'color: #ef4444; font-weight: 600;',
};

const PREFIX = '[Playerso]';

function log(level: LogLevel, message: string, ...args: unknown[]) {
  if (import.meta.env.PROD && level === 'info') return;

  // eslint-disable-next-line no-console
  console.log(`%c${PREFIX} ${message}`, STYLES[level], ...args);
}

export const logger: Logger = {
  info: (message, ...args) => log('info', message, ...args),
  success: (message, ...args) => log('success', message, ...args),
  warn: (message, ...args) => log('warn', message, ...args),
  error: (message, ...args) => log('error', message, ...args),
};
